import { map, negate, overEvery, isUndefined, isNull, toNumber, pipe } from 'lodash/fp';
import isEmptyString from './isEmptyString';
export var isNumeric = overEvery(map(negate, [isUndefined, isNull, isEmptyString, pipe([toNumber, isNaN])]));
export default isNumeric;